import {
  AddOrganisation,
  AddPartnerVenue,
  AddPromoCode,
  AddSeries,
  Admin,
  ArtistsList,
  BulkEventPublisher,
  BulkFlagUploader,
  CFValidation,
  CopyPriceTemplate,
  CopyPromoCode,
  Dashboard,
  DataFields,
  DynamicPriceTemplatesList,
  EditContentOps,
  EditDataField,
  // EditEvent,
  EditFlag,
  EditGlobalAlert,
  EditNavigations,
  EditOptInModal,
  EditOrganisation,
  EditPage,
  EditPriceTemplate,
  EditPromoCode,
  EditSeries,
  EditVlpCustomCard,
  EventsList,
  FixedPriceTemplatesList,
  FlagsList,
  GlobalAlertList,
  MarqueeImageUpload,
  MsgPromoCodesList,
  NavigationsList,
  NewDataField,
  NewFlag,
  NewGlobalAlert,
  NewNavigation,
  NewOptInModal,
  NewPageModule,
  NewPriceTemplate,
  NewVLPCustomCard,
  OptInModals,
  OrganizationsList,
  PagesList,
  PublishingPreferences,
  RedirectsList,
  RockettesPromoCodesList,
  SeriesList,
  TMImportLogsList,
  Uploader,
  VenuesEdit,
  VenuesList,
  VLPCards,
  AddRedirect,
  EditRedirect
} from './'

export const RoutesList = [
  {
    path: '/',
    redirectTo: '/dashboard'
  },
  {
    path: '/admin',
    component: Admin
  },
  {
    path: '/admin/sphere/uploader',
    component: Uploader
  },
  {
    path: '/admin/sphere/bulk-flag-update',
    component: BulkFlagUploader
  },
  {
    path: '/admin/bulk-events-update',
    component: BulkEventPublisher
  },
  {
    component: ArtistsList,
    path: '/artists'
  },
  {
    component: GlobalAlertList,
    path: '/global-alerts'
  },
  {
    component: AddPromoCode,
    path: '/promo_codes/:domain/new'
  },
  {
    component: AddSeries,
    path: '/series/new'
  },
  {
    component: Dashboard,
    path: '/dashboard'
  },
  {
    component: DynamicPriceTemplatesList,
    path: '/price_templates/dynamic'
  },
  {
    component: EditPriceTemplate,
    path: '/price_templates/:id/edit'
  },
  {
    component: CopyPriceTemplate,
    path: '/price_templates/:id/copy'
  },
  {
    component: CopyPromoCode,
    path: '/promo_codes/:id/copy'
  },
  // {
  //   component: EditEvent,
  //   path: '/events/:id/edit'
  // },
  {
    component: EditContentOps,
    path: '/events/:id'
  },
  {
    component: EventsList,
    path: '/events'
  },
  {
    component: EditPromoCode,
    path: '/promo_codes/:id/edit'
  },
  {
    component: EditOrganisation,
    path: '/organizations/:id/edit'
  },
  {
    component: FixedPriceTemplatesList,
    path: '/price_templates/fixed'
  },
  {
    component: MsgPromoCodesList,
    path: '/promo_codes/msg'
  },
  {
    component: NewPriceTemplate,
    path: '/price_templates/:type/new'
  },
  {
    component: OrganizationsList,
    path: '/organizations'
  },
  {
    component: AddOrganisation,
    path: '/organizations/new'
  },
  {
    component: PublishingPreferences,
    path: '/publishing_preferences'
  },
  {
    component: RockettesPromoCodesList,
    path: '/promo_codes/rockettes'
  },
  {
    component: SeriesList,
    path: '/series'
  },
  {
    component: NewNavigation,
    path: '/navigations/new'
  },
  {
    component: EditNavigations,
    path: '/navigations/:id'
  },
  {
    component: NavigationsList,
    path: '/navigations'
  },
  {
    component: NewOptInModal,
    path: '/opt-in-modal/new'
  },
  {
    component: EditOptInModal,
    path: '/opt-in-modal/:id/edit'
  },
  {
    component: OptInModals,
    path: '/opt-in-modal'
  },
  {
    component: EditSeries,
    path: '/series/:id/edit'
  },
  {
    component: PagesList,
    path: '/pages'
  },
  {
    component: DataFields,
    path: '/structured-data'
  },
  {
    component: NewDataField,
    path: '/structured-data/new'
  },
  {
    component: EditDataField,
    path: '/structured-data/:id/edit'
  },
  {
    component: NewPageModule,
    path: '/pages/new'
  },
  {
    component: EditPage,
    path: '/pages/:id/edit'
  },
  {
    component: FlagsList,
    path: '/flags'
  },
  {
    component: NewFlag,
    path: '/flags/new'
  },
  {
    component: NewGlobalAlert,
    path: '/global-alerts/new'
  },
  {
    component: EditFlag,
    path: '/flags/:id/edit'
  },
  {
    component: EditGlobalAlert,
    path: '/global-alerts/:id/edit'
  },
  {
    component: MarqueeImageUpload,
    path: '/mq-img-upload'
  },
  {
    component: TMImportLogsList,
    path: '/tm_import_logs'
  },
  {
    component: AddPartnerVenue,
    path: '/venues/partner/new'
  },
  {
    component: NewVLPCustomCard,
    path: '/venues/venue-landing-cards/new'
  },
  {
    component: EditVlpCustomCard,
    path: '/venues/venue-landing-cards/:id/edit'
  },
  {
    component: VenuesEdit,
    path: '/venues/:id/edit'
  },
  {
    component: VenuesList,
    path: '/venues'
  },
  {
    component: CFValidation,
    path: '/cf-invalidation'
  },
  {
    component: RedirectsList,
    path: '/redirects'
  },
  {
    component: AddRedirect,
    path: '/redirects/new'
  },
  {
    component: EditRedirect,
    path: '/redirects/:id/edit'
  },
  {
    component: VLPCards,
    path: '/venues/venue-landing-cards'
  }
]
